<template>
  <el-dialog
      title="申请转诊"
      :append-to-body="true"
      :visible.sync="showTag"
      width="80%"
      :close-on-click-modal="false"
  >
    <el-row>
      <el-col :span="15">
        <el-form size="mini" ref="form" :model="form" :rules="rules" label-width="80px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="患者姓名" prop="patName">
                <el-input v-model="form.patName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号" prop="patIdcard">
                <el-input v-model="form.patIdcard"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="家庭联系人" prop="familyContactsName">
                <el-input v-model="form.familyContactsName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系手机" prop="familyContactsMobile">
                <el-input v-model="form.familyContactsMobile"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="申请医生" prop="initDocName">
                <el-input v-model="form.initDocName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="医生手机" prop="initDocMobile">
                <el-input v-model="form.initDocMobile"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item class="transfer_hospital" label-width="220px" prop="transferHospital">
            <span slot="label">患方是否知情同意转院意见：</span>
            <el-radio-group v-model="form.transferHospital" :disabled="readonly('transferHospital')">
              <el-radio :label="true">已知情同意</el-radio>
              <el-radio :label="false">不同意</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="会诊意见附件" required>
            <el-upload
                :limit="9"
                :file-list="picList"
                :action="UPLOAD_URL"
                :data="UPLOAD_PARAMS"
                :headers="UPLOAD_HEADERS"
                :on-success="onSuccessPic"
                list-type="picture-card"
                :on-exceed="onExceed"
                :on-error="uploadOnError"
                :before-upload="beforeUpload"
            >
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">最多可上传9张图片，支持jpg、png、gif、bmp格式。</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="附件资料">
            <el-upload
                :action="UPLOAD_URL"
                :file-list="fileList"
                :data="UPLOAD_PARAMS"
                :before-upload="beforeUploadFile"
                :headers="UPLOAD_HEADERS"
                :on-success="onSuccessFile"
            >
              <el-button type="primary">上传资料</el-button>
              <div slot="tip" class="el-upload__tip">仅支持pdf、xls、xlsx、doc、docx、txt、rar、zip、pdf格式，文件小于30M。</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="疾病主诉" prop="patComplaint">
            <el-input type="textarea" v-model="form.patComplaint" :disabled="readonly('patComplaint')"></el-input>
          </el-form-item>
          <el-form-item label="诊断" prop="tentativeDiagnosis">
            <el-input
                type="textarea"
                :disabled="readonly('tentativeDiagnosis')"
                v-model="form.tentativeDiagnosis"
            ></el-input>
          </el-form-item>
          <el-form-item label="关键病情经过" prop="treatmentProcess">
            <el-input
                type="textarea"
                v-model="form.treatmentProcess"
            ></el-input>
          </el-form-item>
          <el-form-item label="图片资料" prop="consultAvatar">
            <el-upload
                :show-file-list="false"
                :action="UPLOAD_URL"
                :data="UPLOAD_PARAMS"
                :headers="UPLOAD_HEADERS"
                :on-success="onSuccessConsultAvatar"
                :on-exceed="onConsultAvatarExceed"
                :on-error="uploadOnError"
                :before-upload="beforeUpload"
            >
              <template v-if="!form.consultAvatar">
                <div class="upload_consultavatar">
                  <i class="el-icon-plus"></i>
                </div>
                <div slot="tip" class="el-upload__tip">支持jpg、png、bmp格式。</div>
              </template>
              <img class="upload_consultavatar_img" v-else :src="form.consultAvatarUrl" alt="">
            </el-upload>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="1" class="flex jcc">
        <div style="height: 330px;border: 1px dotted #ccc"></div>
      </el-col>
      <el-col :span="8">
        <el-form :model="form" label-width="120px" size="mini" :rules="rules">
          <el-form-item label="申请转入医院" prop="hopeHosId">
            <el-select v-model="form.hopeHosId" filterable :style="inputStyle">
              <el-option
                  v-for="(item, index) in hosList"
                  :key="index"
                  :label="item.hosName"
                  :value="item.consultGroupHosId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请转入日期" prop="hopeTime">
            <el-date-picker
                type="datetime"
                :style="inputStyle"
                v-model="form.hopeTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="{disabledDate}"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="意向运送安排" prop="hopeDispatchingCarType">
            <el-select v-model="form.hopeDispatchingCarType" :style="inputStyle">
              <el-option
                  v-for="(item, index) in hopeDispatchingCarType"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="具体转诊要求" style="margin-bottom: 0px">
          </el-form-item>
          <el-form-item label-width="0px">
            <el-input
                type="textarea"
                v-model="form.referralRequirement"
            ></el-input>
          </el-form-item>
          <el-form-item label="意向运送要求" style="margin-bottom: 0px">
          </el-form-item>
          <el-form-item label-width="0px">
            <el-input
                type="textarea"
                v-model="form.hopeTransportRequirement"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <div slot="footer">
      <el-button @click="hide" size="mini">取 消</el-button>
      <el-button type="primary" :loading="requestLoading" @click="sub" size="mini">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {HOPEDISPATCHINGCARTYPE, STAFF_ADD_ORDER_FIELDS} from "../config";
import {systemService} from "../../../common/lib/service/system";
import {staffService} from "../service/staff";
import dayjs from "dayjs";
import {STAFF_ADD_ORDER_SUCCESS, STAFF_PROCESS_ORDER_SUCCESS} from "../events";
import {isDevelopment, isEmpty} from "../../../common/lib/utils";
import {UploadMixin} from "../../../common/lib/mixins/upload";
import {timeFilter} from "../../../common/lib/filters";
import {disabledDate} from "../filter";
import {getRandomDescription, getRandomMobile, getRandomName} from "@/common/lib/mock";
import {handlerResponseText} from "../../../common/lib/cryptojs";

export default {
  name: "add-dialog",
  mixins: [UploadMixin],
  data() {
    let form = {};
    STAFF_ADD_ORDER_FIELDS.forEach(r => {
      form[r] = "";
    });
    return {
      action: '',//[addConsultOrder,edit]
      hosList: [],
      showTag: false,
      consultAvatarList: [],
      rules: {
        patName: [
          {required: true, message: '患者姓名必填'}
        ],
        patIdcard: [
          {required: true, message: '身份证必填'}
        ],
        familyContactsName: [
          {required: true, message: '家庭联系人必填'}
        ],
        familyContactsMobile: [
          {required: true, message: '联系手机必填'}
        ],
        initDocName: [
          {required: true, message: '申请医生必填'}
        ],
        initDocMobile: [
          {required: true, message: '医生手机必填', trigger: 'blur'},
          {pattern: /^1\d{10}$/, message: '手机号格式错误', trigger: 'blur'}
        ],
        patComplaint: [
          {required: true, message: '病情主诉必填'}
        ],
        tentativeDiagnosis: [
          {required: true, message: '诊断必填'}
        ],
        treatmentProcess: [
          {required: true, message: '关键病情经过必填'}
        ],
        hopeHosId: [
          {required: true, message: '申请转入医院必填'}
        ],
        /* hopeTime: [
           {required: true, message: '申请转入日期必填'}
         ],
         hopeDispatchingCarType: [
           {required: true, message: '意向运送安排必填'}
         ],*/
        transferHospital: [
          {required: true, message: '请选择'}
        ]
      },
      form,
      referralStatus: ''
    };
  },
  computed: {
    hopeDispatchingCarType() {
      const {loginInfo, form, hosList} = this;
      const hopeDispatchingCarType = [].concat(HOPEDISPATCHINGCARTYPE);
      return hopeDispatchingCarType.map(r => {
        const item = {...r};
        if (form.hopeHosId) {
          const hos = hosList.find(r => r.consultGroupHosId === form.hopeHosId) || {};
          item.name = item.name.replace("上级医院", hos.hosName || "对方医院");
          item.name = item.name.replace("下级医院", loginInfo.hosName || "本院");
        } else {
          item.name = item.name.replace("上级医院", "对方医院");
          item.name = item.name.replace("下级医院", "本院");
        }
        return item;
      })

    },
    inputStyle() {
      return {width: '190px'};
    }
  },
  watch: {
    'form.hopeDispatchingCarType': function (newV) {
      this.$emit("hopeDispatchingCarTypeChange", newV);
    },
    'form.patIdcard': function (newV) {
      if (isDevelopment() && !this.action && newV.length === 18) {
        this.form.patName = getRandomName();
        this.form.familyContactsMobile = getRandomMobile();
        this.form.familyContactsName = getRandomName();
        this.form.initDocName = getRandomName();
        this.form.initDocMobile = getRandomMobile();
        this.form.patComplaint = getRandomDescription();
        this.form.tentativeDiagnosis = getRandomDescription();
        this.form.treatmentProcess = getRandomDescription();
      }
    }
  },
  methods: {
    disabledDate,
    readonly(field) {
      if (this.action === 'edit') {
        if (this.referralStatus === 'NEED_ARRANGE' && ['transferHospital', 'patComplaint', 'tentativeDiagnosis'].includes(field)) {
          return true;
        }
      }
      return false;
    },
    onSuccessConsultAvatar(response, file, fileList) {
      console.log('consultAvatar', response);
      if (typeof response === 'string') response = handlerResponseText(response);
      if (response && response.code !== "0") {
        this.$message.error(response.msg);
      } else {
        this.form.consultAvatar = response.obj.attaId
        this.form.consultAvatarUrl = response.obj.url;
      }
    },
    onConsultAvatarExceed() {
      this.$message.error(
          "最多可上传1张图片，支持jpg、png、bmp格式。"
      );
    },
    show(data, action = null) {
      this.action = action;
      this.showTag = true;
      if (!isEmpty(data)) {
        this.referralStatus = data.referralStatus;
        STAFF_ADD_ORDER_FIELDS.forEach(r => {
          if (data[r]) this.$set(this.form, r, data[r]);
        });
        data.id && this.$set(this.form, "orderId", data.id);
        data.hopeTime &&
        this.$set(
            this.form,
            "hopeTime",
            timeFilter(data.hopeTime, "YYYY-MM-DD HH:mm:ss")
        );
        if (data.attaList && data.attaList.length) {
          this.picList.splice(0);
          this.fileList.splice(0);
          this.$set(this.form, "attaIdList", data.attaList.map(r => r.attaId));
          data.attaList.forEach(r => {
            if (r.fileType === "IMAGE") {
              this.picList.push({
                name: r.attaFileName,
                url: r.url
              });
            } else {
              this.fileList.push({
                name: r.attaFileName,
                url: r.url
              });
            }
          });
        }
      }
      if (!this.form.hopeDispatchingCarType) this.form.hopeDispatchingCarType = 'OTHER_WAYS'
      this.getHos();
    },
    hide() {
      this.resetForm();
      this.showTag = false;
    },
    resetForm() {
      this.form.orderId = "";
      this.picList.splice(0);
      this.fileList.splice(0);
      this.form.hopeTime = "";
      STAFF_ADD_ORDER_FIELDS.forEach(r => {
        this.$set(this.form, r, "");
      });
    },
    async getHos() {
      this.hosList = await systemService.listHos(this.loginInfo.hosId);
      this.hosList = this.hosList.filter(r => r.consultGroupHosId !== this.loginInfo.hosId);
    },
    sub() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        let form = {...this.form};

        if (!form.transferHospital) {
          this.$alert('请和患者沟通转院意见，需要患者知情同意后才可以申请转诊', '提示', {
            confirmButtonText: '知道了',
            type: 'warning'
          })
          return
        }

        form.hopeTime = dayjs(form.hopeTime).valueOf();
        if (!form.attaIdList || !form.attaIdList.length) {
          form.attaIdList = [];
        }

        if (!this.picList || this.picList.length === 0) return this.$message.error('会诊意见附件不能为空')

        form.attaIdList = [
          ...form.attaIdList,
          ...this.handlerAttaIdList(this.picList),
          ...this.handlerAttaIdList(this.fileList)
        ];

        if (form.consultId && this.action === 'addConsultOrder') {
          const code = await staffService.addConsultOrder(form)
          if (code === '0') {
            this.hide();
            this.$message.success({
              message: "申请成功",
              onClose: () => {
                bus.$emit(STAFF_ADD_ORDER_SUCCESS.id, STAFF_ADD_ORDER_SUCCESS.name);
              }
            });
          }
          return;
        }


        if (form.orderId) {
          if (await staffService.modifyOrder(form)) {
            this.hide();
            this.resetForm();
            this.$message.success({
              message: "修改成功",
              onClose: () => {
                bus.$emit(
                    STAFF_PROCESS_ORDER_SUCCESS.id,
                    STAFF_ADD_ORDER_SUCCESS.name
                );
              }
            });
          }
          return;
        }


        delete form.consultId;
        if (await staffService.addOrder(form)) {
          this.hide();
          this.$message.success({
            message: "添加成功",
            onClose: () => {
              bus.$emit(STAFF_ADD_ORDER_SUCCESS.id, STAFF_ADD_ORDER_SUCCESS.name);
            }
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.transfer_hospital {
  /deep/ {
    label {
      text-align: left;
    }

    .el-form-item__content {
      margin-left: 0px !important;
    }
  }
}

.upload_consultavatar {
  &_img {
    width: 100px;
    height: 100px;
  }

  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px #cccccc dashed;
  border-radius: 5px;
}
</style>
